$(document).ready(function() {
	const aboutSectionToggle = (function() {
		// Toggle About sections
		$(".section-title").click(function() {
			$(this).next('.content').toggleClass('open');
			// Change section title icon
			if ($(this).next().hasClass('open')) {
				$(this).find('i').attr('class', 'fa fa-minus')
			}
			else {
				$(this).find('i').attr('class', 'fa fa-plus')
			}
		})
	})();
});